import React, {useState} from "react";
import { ModalBuilder, Table, Lookup } from "@redriver/cinnamon";
import { LookupTypes } from "../lookups";
import ServiceForm from "./ServiceForm";
import { TranslatedModal } from "../../../components/modals";

const EditServiceModal = ({ submitAction, onSubmitted, service }) => {
    const [uploadDoc, setUploadDoc] = useState(null);

    const onChangeUpload = (file) => {
        let fileReader = new FileReader();
        fileReader.onload = () => {
            const res = fileReader.result;
            setUploadDoc(res);
        };
        fileReader.readAsDataURL(file);
    };
    return (
            <ModalBuilder
                withForm
                initialData={service}
                submitAction={submitAction}
                submitParams={{id: service.id, uploadDoc}}
                onSubmitted={onSubmitted}
                renderTrigger={(showModal) => (
                    <Table.MenuItem onClick={showModal}>Edit</Table.MenuItem>
                )}
                renderModal={(modalProps, formProps) => (
                    <TranslatedModal.Edit
                        {...modalProps}
                        size="small"
                        header="Edit Quarterly Service"
                        submitLabel="Update Quarterly Service"
                    >
                        <ServiceForm
                            formProps={formProps}
                            onChangeUpload={onChangeUpload}
                        />
                    </TranslatedModal.Edit>
                )}
            />
        );
}

export default EditServiceModal;
